<template>
  <div>
    <Sidebar/>
    <div class="content">
      <NavBar />
      <main>
        <div class="header">
          <div class="left">
            <h1>Dashboard</h1>
            <ul class="breadcrumb">
              <li>Inicio</li>
            </ul>
          </div>
        </div>
        <ul class="insights">
          <li class="box-1">
            <i class="bx bx-user"></i>
            <span class="info">
              <h3>{{ subscribers }}</h3>
              <p>Engenheiros</p>
            </span>
          </li>
          <li class="box-2">
            <i class="bx bx-calendar-star"></i>
            <span class="info">
              <h3>{{ plans }}</h3>
              <p>Assinaturas</p>
            </span>
          </li>
          <li class="box-7">
            <i class="bx bx-money"></i>
            <span class="info">
              <h3>{{ amountConvert(amount) }}</h3>
              <p>Faturamento</p>
            </span>
          </li>
        </ul>
      </main>
    </div>
  </div>
</template>
<script>

import Cookie from 'js-cookie'
import NavBar from "@/components/NavBar.vue";
import Sidebar from "@/components/SideBar.vue";

export default {
  components:{
    NavBar,
    Sidebar
  },
  data() {
    return {
      subscribers: 0,
      plans: 0,
      news: 0,
      projects: 0,
      projects_pending: 0,
      amount: 0,
      amount_pending: 0,
      amount_paid: 0,
      users: 0,
      role: 0,
      token: Cookie.get('_token')
    };
  },
  methods: {
    showAlert(type, msg) {
      var textMsg = "";
      if (msg.message) {
        if (typeof msg.errors === 'object' && msg.errors) {
          for (const key in msg.errors) {
            if (Object.prototype.hasOwnProperty.call(msg.errors, key)) {
              const errorMessages = msg.errors[key];
              textMsg += `${errorMessages.join(', ')}<br>`;
            }
          }
        } else {
          textMsg = `${msg.message}`;
        }
      } else {
        textMsg = `${msg}`;
      }

      this.$swal({
        text: textMsg,
        icon: type,
        confirmButtonText: 'Confirmar',
        html: textMsg
      });
      
    },
    amountConvert(value) {
      const valueAmount = (value)? value : 0;
      return valueAmount.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    },
    
    load() {
      this.$http
        .get("/admin/home", {
          headers: {
            "Authorization": "Bearer " + this.token
          },
        })
        .then((response) => {

          this.subscribers = response.data.items.subscribers;
          this.plans = response.data.items.plans;
          this.amount = response.data.items.amount;

        })
        .catch((error) => {
          if (error.response && error.response.data) {
            this.showAlert('error', error.response.data);
          } else {
            this.showAlert('error', 'Ocorreu um erro desconhecido. Entre em contato com a equipe de desenvolvimento.');
          }

        });
    },
  },
  created() {
    this.load();
    this.role = this.$store.state.role;
  },
};
</script>